// extracted by mini-css-extract-plugin
module.exports = {"Box":"Staffs_Box__3i2_3","BoxRow":"Staffs_BoxRow__1GSOf","AddIcon":"Staffs_AddIcon__3H-4G","BoxTitle":"Staffs_BoxTitle__1nwCk"};